import { Alert, Button, Input } from '30pay/components';
import { useEffect, useRef, useState } from 'react';
import { post } from 'scripts';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { ConvertBoxDataType } from '../../convertBox.index';
import { API } from 'data/30pay.api';
import { __TypeOfOrderEnum } from '../../initial/initial.interface';
import ConvertBoxConfirmOrderModal from '../../confirmOrderModal/orderDetailModal.index';
import { __ConvertBoxConfirmOrderDetailModalRef } from '../../confirmOrderModal/orderDetailModal.interface';
import { __SellUUSDDepositConvertBoxProps } from './sellUUSDDeposit.interface';
import { Enum } from '../../../../../interfaces';
import { __SellWithdrawMethodsEnums } from '../../sellWithdrawMethod/sellWithdrawMethod.interface';

const SellUUSDDeposit: React.FC<__SellUUSDDepositConvertBoxProps> = (props: __SellUUSDDepositConvertBoxProps) => {
    const [voucherCode, setVoucherCode] = useState<string | undefined>();
    const [confirmData, setConfirmData] = useState<ConvertBoxDataType>();
    const confirmModalRef = useRef<__ConvertBoxConfirmOrderDetailModalRef>(null);

    function submitHandler() {
        confirmModalRef.current?.startLoading();
        const { data } = props;
        const body = {
            iBanNumberId: data?.withdrawMethod === __SellWithdrawMethodsEnums.iBan ? data?.bankAccountId : undefined,
            destination: data?.withdrawMethod,
            voucherCode,
        };
        post<{ trackingCode: string; voucherAmount: number; amount: number; state: Enum }>(
            API.orderTransaction.sellUUSD,
            body,
        )
            .then((res) => {
                confirmModalRef.current?.showResultContent(true, res.value.value.trackingCode, {
                    sourceAmount: res.value.value.voucherAmount,
                    destinationAmount: res.value.value.amount,
                    state: res.value.value.state,
                });
            })
            .catch((e) => confirmModalRef.current?.showResultContent(false))
            .finally(() => confirmModalRef.current?.stopLoading());
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <ConvertBoxConfirmOrderModal
                ref={confirmModalRef}
                data={props.data}
                isOpen={!!confirmData}
                onClose={(needReFetch) => {
                    setConfirmData(undefined);
                    needReFetch && props.onFinish();
                }}
                submitButton={{
                    title: 'ثبت سفارش',
                    onClick: submitHandler,
                }}
            />
            <Card className="flex-1" title="واریز ارز مبدا" titleDivider>
                <div className="flex flex-col gap-6">
                    <div className="gap-2 flex flex-col">
                        <label className="font-bold text-base text-black-100 en text-right">کد ووچر</label>
                        <Input
                            className={voucherCode && voucherCode !== '' ? 'en' : ''}
                            value={voucherCode}
                            onPressEnter={() => setConfirmData(props.data)}
                            onChange={(e) => setVoucherCode(e.target.value)}
                            placeholder="لطفا کد ووچر خود را وارد نمایید."
                        />
                    </div>
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button
                        disabled={!voucherCode || voucherCode === ''}
                        onClick={() => setConfirmData(props.data)}
                        className="w-full h-16"
                        type="primary"
                    >
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert
                    message=" چنانچه ارزش واقعی ووچر شما با مقداری که در مرحله قبل وارد شده است متفاوت باشد، ارزش واقعی ووچر برای پرداخت محاسبه خواهد شد."
                    variant="warning"
                />
            </div>
        </div>
    );
};
export default SellUUSDDeposit;
